module.exports = __webpack_public_path__ + "static/media/wonder-woman@3x.61168133.png";